import { Box, Button, Center, Flex, Grid, GridItem, Input, InputGroup, InputLeftElement, Spinner, Text, useToast } from '@chakra-ui/react'
import Header from '../../../components/Header'
import { HeadingPages } from '../../../components/HeadingPages'
import * as S from './styles'
import { FiUpload } from 'react-icons/fi'
import { IoImagesOutline } from 'react-icons/io5'
import { FaShareAltSquare } from 'react-icons/fa'
import { useEffect, useState } from 'react'
import { CardImage } from './CardImage'
import Axios from 'axios'
import { user } from '../../../helpers/user'
import { ViewImage } from './ViewImage'

export function UploadImages() {
  const [selectedField, setSelectedField] = useState('myImages')
  const [selectedImages, setSelectedImages] = useState([])
  const [loading, setLoading] = useState(false)
  const [listImages, setListImages] = useState([])
  const [typeArchieve, setTypeArchieve] = useState('')
  const [loadingListImages, setLoadingListImages] = useState(false)

  const codUsu = user?.codigo_usuario

  const handleImageChange = (event) => {
    const files = Array.from(event.target.files)
    setSelectedImages(files)
  }

  const toast = useToast()

  async function onSubmit() {
    setLoading(true)
    const formData = new FormData()

    formData.append('codigo_usuario', codUsu)

    selectedImages.forEach((image, index) => {
      formData.append(`imagem[]`, image)
    })

    console.log('formData', selectedImages)

    try {
      const response = await Axios.post('https://api.innovationbrindes.com.br/api/site/v2/fluxo-imagem/upload-arquivo-amazon', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })

      console.log('response', response.data)
      setLoading(false)
      toast({
        title: 'Imagens enviadas com sucesso!',
        status: 'success',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      })

      getListImages()
    } catch (error) {
      console.error(error)
      setLoading(false)
      toast({
        title: 'Erro ao enviar imagens!',
        status: 'error',
        duration: 3000,
        isClosable: true,
        position: 'top-right',
      })
      setSelectedImages([])
    }

    setSelectedImages([])
  }

  async function getListImages() {
    setLoadingListImages(true)
    const isMyImages = selectedField === 'myImages' ? codUsu : ''

    const response = await Axios.get(`${process.env.REACT_APP_BASE_URL}/site/v2/fluxo-imagem/lista-imagens-usuario/${isMyImages}`)

    console.log('response', response.data)
    setListImages(response.data)
    setLoadingListImages(false)
  }

  useEffect(() => {
    getListImages()
  }, [selectedField])

  return (
    <>
      <HeadingPages name="Upload de arquivos" />

      <Flex maxW={1480} mx="auto" w="100%" my="6" px="6" flexDir="column">
        <Flex gap={5} h="calc(100vh - 80px - 160px)">
          <Flex bgColor="#fff" w="500px" borderRadius="md" boxShadow="0 0 3px rgba(0,0,0,.1)" flexDir="column" alignItems="flex-start">
            <Flex mb="1rem" w="100%" p={2} flexDir="column" gap={2} as="form">
              <S.Inputas id={`aws-upload-item`} type="file" multiple onChange={handleImageChange} />
              <S.Label htmlFor={`aws-upload-item`}>
                <S.Textas>Selecione uma ou mais fotos</S.Textas>
                <FiUpload />
              </S.Label>

              <Button
                colorScheme="blue"
                ml="auto"
                onClick={() => onSubmit()}
                disabled={selectedImages.length === 0}
                isLoading={loading}
                loadingText="Enviando"
              >
                Enviar
              </Button>
            </Flex>
            <Box
              w="100%"
              bgColor={selectedField === 'myImages' ? '#e5e5e5' : '#f5f5f5'}
              px="1rem"
              py="0.5rem"
              _hover={{
                cursor: 'pointer',
                bgColor: '#e5e5e5',
              }}
              onClick={() => setSelectedField('myImages')}
            >
              <Flex gap={2} align="center">
                <IoImagesOutline size={20} />

                <Text>Meus arquivos</Text>
              </Flex>
            </Box>
            <Box
              w="100%"
              bgColor={selectedField === 'otherImages' ? '#e5e5e5' : '#f5f5f5'}
              px="1rem"
              py="0.5rem"
              _hover={{
                cursor: 'pointer',
                bgColor: '#e5e5e5',
              }}
              onClick={() => setSelectedField('otherImages')}
            >
              <Flex gap={2} align="center">
                <FaShareAltSquare size={20} />
                <Text>Outros arquivos</Text>
              </Flex>
            </Box>
          </Flex>
          <Grid
            templateColumns="repeat(auto-fill, minmax(200px, 1fr))"
            gap={5}
            borderRadius="md"
            boxShadow="0 0 3px rgba(0,0,0,.1)"
            bgColor="#fff"
            w="100%"
            overflowY="auto"
            maxW="calc(100vw - 500px)"
            padding="1rem"
            flexWrap="wrap"
            //estilizar scroll
            css={{
              '&::-webkit-scrollbar': {
                width: '4px',
                height: '4px',
              },
              '&::-webkit-scrollbar-track': {
                background: '#f1f1f1',
              },
              '&::-webkit-scrollbar-thumb': {
                background: '#888',
              },
              '&::-webkit-scrollbar-thumb:hover': {
                background: '#555',
              },
            }}
          >
            {listImages.length === 0 && !loadingListImages && (
              <GridItem colSpan={4} display="flex" flexDir="column" alignItems="center" justifyContent="center">
                <Text>Nenhuma imagem encontrada</Text>
              </GridItem>
            )}
            {loadingListImages && (
              <GridItem colSpan={4} display="flex" flexDir="column" alignItems="center" justifyContent="center">
                <Spinner size="xl" />
                <Text mt="1rem">Carregando...</Text>
              </GridItem>
            )}
            {!loadingListImages &&
              listImages.map((item, index) => (
                <ViewImage key={index} item={item} getListImages={getListImages} excludeButton={selectedField === 'myImages'} />
              ))}
          </Grid>
        </Flex>
      </Flex>
    </>
  )
}
